<template>
    <div class="w-100 background-aliceblue" >
        <div class="w-100 pt-2" v-if="!separated" >
            <drop class="ml-4 mr-2 cut" @drop="onDrop" mode="cut" :accepts-data="onAcceptData">
                <c-card-iterator
                    v-if           = "recipients"
                    :label         = "title"
                    :items         = "recipients"
                    :filter-height = "180"
                    :item-height   = "190"
                    :height        = "800"
                    :enable-search = "false"
                    :zoom          = "false"
                    :left-arrow    = "false"
                    :show-filter   = "false"
                    class          = "w-100"
                    background="background-aliceblue"
                >
                    <template v-slot:card="{ item }">
                        <c-recipient-card
                            style        = "width: calc(100% - 1px)"
                            :company     = "item.recipient"
                            :enable-edit = "false"
                        >
                            <template v-slot:toolbar>
                                <div style="margin-top: -4px;">
                                    <c-toolbar-button
                                        icon    = "mdi-close"
                                        size    = "22"
                                        color   = "red"
                                        tooltip = "Entfernen"
                                        @click  = "onRemove(item)"
                                    />
                                </div>
                            </template>
                        </c-recipient-card>
                    </template>
                </c-card-iterator>
            </drop>
        </div>

        <div class="w-100 pt-2" v-if="separated">
            <c-column-header :label="title" class="primary mt-2 mr-2 ml-2 pb-0" />
            <c-site-recipients-separated
                title            = "Störungen usw."
                class            = "mt-3"
                :recipients      = "incidents"
                :accept-property = "acceptProperty"
                usage            = "INCIDENT"
                @assign          = "onAssign"
                @remove          = "onRemove"
            />

            <c-site-recipients-separated
                title            = "Wartungs-, Notruf- und ZÜS-Rechnungen"
                class            = "mt-6"
                :recipients      = "costs"
                :accept-property = "acceptProperty"
                usage            = "COSTS"
                @assign          = "onAssign"
                @remove          = "onRemove"
            />

            <c-site-recipients-separated
                title            = "Reparaturen"
                class            = "mt-6"
                :recipients      = "repairs"
                :accept-property = "acceptProperty"
                usage            = "REPAIR"
                @assign          = "onAssign"
                @remove          = "onRemove"
            />
        </div>
    </div>
</template>

<script>

import { Drop }              from "vue-easy-dnd"
import CCardIterator from "@/modules/core/components/utils/CCardIterator";
import CRecipientCard from "@/modules/msd/company/recipient/components/CRecipientCard";
import CColumnHeader from "@/modules/core/components/utils/CColumnHeader";
import CSiteRecipientsSeparated from "@/modules/msd/unit/components/dialog/CSiteRecipientsSeparated";
import Site from "@/modules/msd/unit/service/Site";
import CToolbarButton from "@/modules/core/components/utils/CToolbarButton";

export default {
    name: "CSiteRecipientsColumn",
    components: {
        CToolbarButton,
        CSiteRecipientsSeparated,
        CColumnHeader,
        CRecipientCard,
        CCardIterator,
        Drop
    },

    props: {
        title: {
            required: true,
            type     : String
        },

        recipients: {
            required: true,
            type     : Array
        },

        acceptProperty: {
            required: true,
            type     : String
        },

        separated: {
            required: true,
            type    : Boolean
        }
    },

    data: () => ({
        USAGE: Site.RECIPIENT.USAGE,
        TYPE : Site.RECIPIENT.TYPE,
    }),

    computed: {
        incidents () {
            return this.recipients.filter(r => r.usage === this.USAGE.INCIDENT);
        },

        costs () {
            return this.recipients.filter(r => r.usage === this.USAGE.COSTS);
        },

        repairs () {
            return this.recipients.filter(r => r.usage === this.USAGE.REPAIR);
        }
    },

    methods: {
        onEdit (recipient) {
            this.$emit("edit", recipient);
        },

        onDrop (event) {
            let type = null;
            switch (this.acceptProperty) {
                case "invoice":
                    type = this.TYPE.INVOICE;
                    break;
                case "benefit":
                    type = this.TYPE.BENEFIT;
                    break;
            }

            this.$emit("assign", {
                recipient: event.data,
                type     : type,
                usage    : this.USAGE.INCIDENT,
            })
        },

        onAssign (event) {
            this.$emit("assign", event);
        },

        onRemove (event) {
            this.$emit("remove", event);
        },

        onAcceptData (recipient) {
            return recipient[this.acceptProperty];
        }
    }
}
</script>

<style scoped>

</style>